<template>
  <div>
    <div v-show="loading">
      <Loading />
    </div>
    <div v-if="errored">
      <ErrorPage />
    </div>
    <div v-else-if="notfound">
      <NotFound titulo="Promoções" />
    </div>
    <div v-else-if="notfound">
      <NotFound titulo="Informações de Happy e Promoções" />
    </div>
    <div v-else class="food-page-section content-size section-home-noradius">
      <div class="wrap-food-recipe">
        <div class="heading-page-item">{{ textoTitulo }}</div>

        <div class="section-news-page">
          <div class="news-wrap">
            <div v-if="exibeImagem(caminhoImagem)">
              <Imagem :caminhoImagem="caminhoImagem"></Imagem>
              <br />
            </div>
            <p class="news-content">{{ textoDescricao }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorPage from "@/components/template/ErrorPage";
import NotFound from "@/components/template/NotFound";
import Loading from "@/components/template/Loading";
import Imagem from "@/components/Imagem";

import FunctionsMixin from '@/utils/functionsMixin.js'
import modulePagina from '@/store/paginas/modulePagina.js';

export default {
  name: "Cardapios-HappyPromocoes",

  components: {
    ErrorPage,
    NotFound,
    Loading,
    Imagem
  },

  mixins: [FunctionsMixin],

  data() {
    return {
      loading: false,
      errored: false
    };
  },

  computed: {
    stateHappyPromo() {
      return this.$store.state.modulePaginas.happyPromo
    },
    notfound() {
      return this.stateHappyPromo ? false : true
    },
    caminhoImagem() {
      return this.stateHappyPromo ? this.stateHappyPromo.imagem : ''
    },
    textoTitulo() {
      return this.stateHappyPromo ? this.stateHappyPromo.titulo : ''
    },
    textoDescricao() {
      return this.stateHappyPromo ? this.stateHappyPromo.descricao : ''
    }
  },

  created() {
    if (!modulePagina.isRegistered) {
      this.$store.registerModule('modulePaginas', modulePagina)
      modulePagina.isRegistered = true
    }

    if (!this.stateHappyPromo) {
      const data = {
        estabelecimentoId: this.$store.state.dadosEstabelecimento.estabelecimentoId,
        tipoPagina: 'happypromocoes'
      }
      this.$store.dispatch('modulePaginas/fetchPaginaHappyPromocoes', data)
    }
  }
};
</script>

<style>
.submit-btn {
  padding-top: 15px;
}

.space {
  padding-left: 8px;
}
</style>
